__turbopack_context__.v({
  "alert": "CompetitionRegistrationModal-module__-DgF5G__alert",
  "body": "CompetitionRegistrationModal-module__-DgF5G__body",
  "dialog": "CompetitionRegistrationModal-module__-DgF5G__dialog",
});
